import { gql } from '@apollo/client';
export const ASSESSMENT_TOOL_FIELDS = gql`
  fragment AssessmentTool on AssessmentToolReadDto {
    id
    parentId
    relatedId
    relatedObjectTypeId
    code
    name
    weighing
    order
    saveForNextExamCall
    qualificationType
    minGrade
    maxGrade
    assessmentTypeTreeLevel1
    assessmentTypeTreeLevel2
    assessmentTypeTreeLevel3
    assessmentTypeTreeLevel4
  }
`;